module.exports = [{"type":"github","username":"chpwssn"},{"type":"twitter","username":"chpwssn"},{"type":"keybase","username":"chipw"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/social.json
// module id = 39
// module chunks = 0